import { io } from 'socket.io-client'

import env from '../environments'

const URL = env.apiUrl

export function initSocket(accessToken: string) {
	return io(URL, {
		extraHeaders: {
			authorization: `Bearer ${accessToken}`
		}
	})
}

